import { createEvent, createStore } from 'effector'

export const actions = {
  setControleQuestions: createEvent<ControleQualiteQuestionResponse[]>('setControleQuestions'),
  resetControleQuestions: createEvent('resetControleQuestions'),
  reset: createEvent('reset'),
}

const initialState: QuestionsState = {
  controle: [],
}

export const store = createStore<QuestionsState>(initialState, { name: 'question' })
  .on(actions.setControleQuestions, (s, controle) => ({ ...s, controle }))
  .on(actions.resetControleQuestions, (s) => ({ ...s, controle: initialState.controle }))
  .reset(actions.reset)
